import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '../store/account.reducer';

@Component({
    selector: 'ef-account-container',
    templateUrl: './account-container.component.html',
    styleUrls: ['./account-container.component.scss'],
    standalone: false
})
export class AccountContainerComponent implements OnInit {
    constructor(private store: Store<fromStore.State>) {}

    ngOnInit() {}
}
